import { useState, useRef, useEffect } from 'react';
import styles from './styles.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

export default function DropMenu({ options = ['enter', 'options'], onSelect = () => {}, placeholder = "Select", defaultValue, onMenuItemClick, shouldChangePlaceholder = true, position = 'bottom' }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(defaultValue || null);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSelect = (option) => {
    if(shouldChangePlaceholder) setSelected(option);
    onSelect(option);

    if (onMenuItemClick) {
      onMenuItemClick(option);
    }

    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={styles.dropMenuWrapper} ref={dropdownRef}>
      <button onClick={toggleDropdown}>
        <h1>{selected ? selected : placeholder}</h1>
        <FontAwesomeIcon icon={faChevronDown} id={styles.icon} />
      </button>
      {isOpen && (
        <section id={styles.menu} style={position === 'top' ? { bottom: '100%' } : { top: '100%' }}>
          {options.map((option, index) => (
            <h1 key={index} onClick={() => handleSelect(option)}>
              {option}
            </h1>
          ))}
        </section>
      )}
    </div>
  );
}
